export default "__VITE_ASSET__DkDaq4az__"